import { MasterdataCustomer } from '../types/masterdata-entities';
import { MasterdataEntityDefinition } from '../types/masterdata-entity-definition';
import { MASTERDATA_CUSTOMER } from './customer';

/**
 * Construction site (Baustelle) — a customer sub-account (subnumber != 0) queried
 * through the customer endpoint; no bookmarks (they would mix with the customer
 * field's), no detail pane. Callers restrict to one customer via `[filter]`.
 */
export const MASTERDATA_CONSTRUCTION_SITE: MasterdataEntityDefinition<MasterdataCustomer> =
  {
    ...MASTERDATA_CUSTOMER,
    name: 'construction-site',
    endpoint: 'customer',
    defaultFilter: [
      { type: 'numberNotEquals', name: 'customerSubnumber', value: 0 },
      { type: 'booleanIsTrue', name: 'active' },
      { type: 'booleanIsFalse', name: 'blocked' },
    ],
    bookmarkSubCategory: undefined,
    icon: 'fa-regular fa-person-digging',
    title: 'Baustellensuche',
    label: 'Baustelle',
    placeholder: 'Baustelle suchen...',
    detailSidebar: false,
    detailComponent: undefined,
    detailInputs: undefined,
  };
